module.exports = __webpack_public_path__ + "static/img/img-honda-supra-gtr.00637d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-honda-supra-gtr.png
// module id = 4/VX
// module chunks = 36